/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react';
import DashboardShimmer from './DashboardShimmer';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from 'react-redux';
import './Dashboard.scss';
import { DashBreadcrumb } from '../../../components/Common/Breadcrumb';
import {
  fetchReturnDashboardData,
} from '../../../common/data/action/dashboardaction';
import 'react-datepicker/dist/react-datepicker.css';
import 'flatpickr/dist/themes/material_blue.css';
import moment from 'moment';
import 'react-loading-skeleton/dist/skeleton.css';
import { DateRangePicker } from 'rsuite';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardTitle,
  CardHeader,
} from 'reactstrap';
import LineColumnArea from './LineColumnArea';
import { STORES } from '../../../constants/showRoomCodes';
import { set } from 'date-fns';

const ReturnDashboard = () => {
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(
    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss')
  );
  const { afterToday, combine, allowedMaxDays } = DateRangePicker;
  const [endDate, setEndDate] = useState(
    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
  );
  const [store, setStore] = useState('All');
  const noImage = 'https://ecowaterqa.vtexassets.com/arquivos/ids/157229/stillnoimageavailable.jpg?v=637179147614330000';

  const [isLoading, setIsLoading] = useState(true);

  const { returnSummaryData = [], isSummeryLoading } = useSelector(
    (state) => state.dashboard
  );

  let isMobileView = 0;
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  if (windowSize.innerWidth <= 1279 && isMobileView === 0) {
    isMobileView++;
  }

  let cntry = localStorage.getItem('WEBSITE_COUNTRY');

  if (cntry !== 'all' && cntry !== null) {
    cntry = cntry?.toUpperCase();
  }

  useEffect(() => {
    setIsLoading(true);
    fetchReturnDashboardData({
      params: {
        date_from: startDate,
        date_to: endDate === undefined || endDate === '' ? startDate : endDate,
        country: cntry,
        store: store,
      },
      dispatch,
    });
  }, [startDate, endDate, cntry, store, dispatch]);

  useEffect(() => {
    // When returnSummaryData updates, stop shimmer
    if (returnSummaryData && Object.keys(returnSummaryData).length > 0) {
      setIsLoading(false);
    }
  }, [returnSummaryData]);

  const returnDashboardData = {
    ...returnSummaryData?.data,
    most_returned_items: returnSummaryData?.data?.top_returned_skus,
  };

  const currencyData = {
    all: 'AED',
    AE: 'AED',
    OM: 'OMR',
    BH: 'BHD',
    QA: 'QAR',
    KW: 'KWD',
  };

  // Helper to format numbers as 1k, 2k, etc.
  function formatNumberShort(num) {
    if (num === null || num === undefined || isNaN(Number(num))) return '0';
    num = Number(num);
    if (num >= 1e9) return (num / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
    if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
    if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'k';
    return num.toString();
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Overview | Returns Dashboard</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          {(isLoading || isSummeryLoading) ? (
            <DashboardShimmer />
          ) : (
            <>
          <Row>
            <Col xl={6}>
              <DashBreadcrumb
                title="Returns & Cancellation"
                breadcrumbItem="Overview"
              />
            </Col>
            <Col xl={6} className="textAlignRight language">
              <div className="selectDashBoardOption">
                <select
                  className="form-control form-select"
                  name="store"
                  value={store}
                  onChange={(e) => {
                    setStore(e?.target?.value);
                  }}
                >
                  <option value="All">All</option>
                  {(() => {
                    if (!cntry || cntry === 'all') {
                      // Flatten all stores from all countries
                      return Object.entries(STORES)
                        .flatMap(([country, stores]) => Object.entries(stores))
                        .map(([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        ));
                    } else if (STORES[cntry]) {
                      // Show only stores for selected country
                      return Object.entries(STORES[cntry]).map(
                        ([key, value]) => (
                          <option key={key} value={key}>
                            {value}
                          </option>
                        )
                      );
                    } else {
                      return null;
                    }
                  })()}
                </select>
              </div>

              <div className="DashbordFliter">
                {isMobileView !== 0 ? (
                  <>
                    <DateRangePicker
                      placement="auto"
                      placeholder="Select Date Range"
                      onClean={() => {
                        setStartDate(
                          new moment(new Date()).format('YYYY-MM-DD')
                        );
                        setEndDate(new moment(new Date()).format('YYYY-MM-DD'));
                      }}
                      showOneCalendar
                      onChange={(selectedDates, instance) => {
                        const dateStr = selectedDates?.[0];
                        const first_Date = new Date(dateStr)?.toString();
                        const firstD = moment(new Date(first_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const firstDateReplace = firstD?.replaceAll('/', '-');
                        const dateStr1 = selectedDates?.[1];
                        const second_Date = new Date(dateStr1)?.toString();
                        const secondD = moment(new Date(second_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const secondDateReplace = secondD?.replaceAll('/', '-');
                        setStartDate(firstDateReplace);
                        setEndDate(secondDateReplace);
                      }}
                    />
                  </>
                ) : (
                  <>
                    <DateRangePicker
                      placement="leftStart"
                      placeholder="Select Date Range"
                      onClean={() => {
                        setStartDate(
                          new moment(new Date()).format('YYYY-MM-DD')
                        );
                        setEndDate(new moment(new Date()).format('YYYY-MM-DD'));
                      }}
                      // disabledDate={combine(allowedMaxDays(30), afterToday())}
                      onChange={(selectedDates, instance) => {
                        const dateStr = selectedDates?.[0];
                        const first_Date = new Date(dateStr)?.toString();
                        const firstD = moment(new Date(first_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const firstDateReplace = firstD?.replaceAll('/', '-');
                        const dateStr1 = selectedDates?.[1];
                        const second_Date = new Date(dateStr1)?.toString();
                        const secondD = moment(new Date(second_Date))?.format(
                          'YYYY/MM/DD'
                        );
                        const secondDateReplace = secondD?.replaceAll('/', '-');
                        setStartDate(firstDateReplace);
                        setEndDate(secondDateReplace);
                      }}
                    />{' '}
                  </>
                )}
              </div>
            </Col>
          </Row>
          
            <Row
              className="row-fluid-scroll flex-nowrap mb-4"
              style={{ overflowX: 'scroll' }}
            >
              <Col xl={3} md={5}>
                <Card className="TotalOrderCard">
                  <CardBody className="p-4">
                    <p>Today Return Requests</p>
                    <div className="">
                      <div className="row align-items-center">
                        <div className="col-12">
                          <h2>{`${currencyData[cntry]} ${formatNumberShort(
                            returnDashboardData?.total_sales_amount
                          )}`}</h2>
                        </div>
                        {/* <div className='col-6 d-flex justify-content-end'>
                            <span
                              role="button"
                              tabIndex={0}
                              onClick={() => {
                                const icon = document.getElementById('refresh-anim-icon');
                                if (icon) {
                                  icon.classList.add('spin-anim');
                                  setTimeout(() => {
                                    icon.classList.remove('spin-anim');
                                  }, 1000);
                                }
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <i
                                id="refresh-anim-icon"
                                className="bx bx-refresh"
                                style={{ fontSize: 'xx-large', border: '1px solid #0980FD', borderRadius: '50%', padding: '5px', transition: 'transform 0.5s', color: '#0980FD' }}
                              ></i>
                            </span>
                          </div> */}
                        </div>
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="mb-2">No. of Request <span style={{color: 'green', fontSize: '18px'}}>{returnDashboardData?.total_return_requests}</span></p>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={5}>
                  <Card className="TotalOrderCard">
                    <CardBody className='p-4'>
                      <p>Today Approved Return Requests</p>
                      <div className="">
                        <div className='row align-items-center'>
                          <div className='col-12'>
                            <h2>{`${currencyData[cntry]} ${formatNumberShort(returnDashboardData?.approved_sales_amount)}`}</h2>
                          </div>
                          {/* <div className='col-6 d-flex justify-content-end'>
                            <span
                              role="button"
                              tabIndex={0}
                              onClick={() => {
                                const icon = document.getElementById('refresh-approved-icon');
                                if (icon) {
                                  icon.classList.add('spin-anim');
                                  setTimeout(() => {
                                    icon.classList.remove('spin-anim');
                                  }, 1000);
                                }
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <i
                                id="refresh-approved-icon"
                                className="bx bx-refresh"
                                style={{ fontSize: 'xx-large', border: '1px solid #0980FD', borderRadius: '50%', padding: '5px', transition: 'transform 0.5s', color: '#0980FD' }}
                              ></i>
                            </span>
                          </div> */}
                        </div>
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="mb-2">No. of Request  <span style={{color: 'green', fontSize: '18px'}}>{returnDashboardData?.approved_return_requests}</span></p>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={5}>
                  <Card className="TotalOrderCard">
                    <CardBody className='p-4'>
                      <p>Today Authorized Return Requests</p>
                      <div className="">
                        <div className='row align-items-center'>
                          <div className='col-12'>
                            <h2>{`${currencyData[cntry]} ${formatNumberShort(returnDashboardData?.authorized_sales_amount)}`}</h2>
                          </div>
                          {/* <div className='col-6 d-flex justify-content-end'>
                            <span
                              role="button"
                              tabIndex={0}
                              onClick={() => {
                                const icon = document.getElementById('refresh-approved-icon');
                                if (icon) {
                                  icon.classList.add('spin-anim');
                                  setTimeout(() => {
                                    icon.classList.remove('spin-anim');
                                  }, 1000);
                                }
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <i
                                id="refresh-approved-icon"
                                className="bx bx-refresh"
                                style={{ fontSize: 'xx-large', border: '1px solid #0980FD', borderRadius: '50%', padding: '5px', transition: 'transform 0.5s', color: '#0980FD' }}
                              ></i>
                            </span>
                          </div> */}
                        </div>
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="mb-2">No. of Request  <span style={{color: 'green', fontSize: '18px'}}>{returnDashboardData?.authorized_return_requests}</span></p>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl={3} md={5}>
                  <Card className="TotalOrderCard">
                    <CardBody className='p-4'>
                      <p>Today Rejected Return Requests</p>
                      <div className="">
                        <div className='row align-items-center'>
                          <div className='col-12'>
                            <h2>{`${currencyData[cntry]} ${formatNumberShort(returnDashboardData?.rejected_sales_amount)}`}</h2>
                          </div>
                          {/* <div className='col-6 d-flex justify-content-end'>
                            <span
                              role="button"
                              tabIndex={0}
                              onClick={() => {
                                const icon = document.getElementById('refresh-rejected-icon');
                                if (icon) {
                                  icon.classList.add('spin-anim');
                                  setTimeout(() => {
                                    icon.classList.remove('spin-anim');
                                  }, 1000);
                                }
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              <i
                                id="refresh-rejected-icon"
                                className="bx bx-refresh"
                                style={{ fontSize: 'xx-large', border: '1px solid #0980FD', borderRadius: '50%', padding: '5px', transition: 'transform 0.5s', color: '#0980FD' }}
                              ></i>
                            </span>
                          </div> */}
                        </div>
                        <div className="d-flex justify-content-between">
                          <div>
                            <p className="mb-2">
                              No. of Request{' '}
                              <span style={{ color: 'green', fontSize: '18px' }}>
                                {returnDashboardData?.rejected_return_requests}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            

          <Row>
            <>
              {' '}
              <Col xl={8}>
                <Card>
                  <CardHeader className="d-sm-flex align-items-center justify-content-between">
                    <CardTitle>Returns Summary</CardTitle>
                  </CardHeader>
                  <>
                    <CardBody>
                      <div dir="ltr">
                        <LineColumnArea
                          returnDashboardData={returnDashboardData}
                          store={store}
                        />
                      </div>
                    </CardBody>
                  </>
                </Card>
              </Col>
              <Col xl={4}>
                <Card style={{ height: '-webkit-fill-available' }}>
                  <CardHeader className="d-sm-flex align-items-center justify-content-between">
                    <CardTitle>Returns Status Summary</CardTitle>
                  </CardHeader>
                  <>
                    <CardBody>
                      <div dir="ltr">
                        {returnDashboardData?.c_summary &&
                          Object.entries(returnDashboardData.c_summary).map(
                            ([key, value]) => (
                              <div key={key} style={{ marginBottom: '18px' }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '6px',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: 'bold',
                                      textTransform: 'capitalize',
                                    }}
                                  >
                                    {key}
                                  </span>
                                  <span style={{ fontWeight: 'bold' }}>
                                    {value.percentage}%
                                  </span>
                                </div>
                                <div
                                  style={{
                                    width: '100%',
                                    background: '#e9ecef',
                                    borderRadius: '8px',
                                    height: '10px',
                                    position: 'relative',
                                  }}
                                >
                                  <div
                                    style={{
                                      width: `${value.percentage}%`,
                                      background: '#435185',
                                      height: '100%',
                                      borderRadius: '8px',
                                      transition: 'width 0.6s',
                                    }}
                                  ></div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </CardBody>
                      </>
                    
                  </Card>
                </Col>
                <Col xl={12}>
                  <Card style={{height: '-webkit-fill-available'}}>
                    <CardHeader className="d-sm-flex align-items-center justify-content-between">
                      <CardTitle>Most Returned Items</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div dir="ltr">
                        {/* Carousel for Most Returned Items */}
                        {returnDashboardData?.most_returned_items && returnDashboardData.most_returned_items.length > 0 ? (
                          <Carousel
                            additionalTransfrom={0}
                            arrows
                            autoPlaySpeed={3000}
                            centerMode={false}
                            className=""
                            containerClass="carousel-container"
                            dotListClass=""
                            draggable
                            focusOnSelect={false}
                            infinite
                            itemClass="carousel-item-padding-40-px"
                            keyBoardControl
                            minimumTouchDrag={80}
                            renderButtonGroupOutside={false}
                            renderDotsOutside={false}
                            responsive={{
                              superLargeDesktop: {
                                breakpoint: { max: 4000, min: 1200 },
                                items: 4
                              },
                              desktop: {
                                breakpoint: { max: 1200, min: 992 },
                                items: 4
                              },
                              tablet: {
                                breakpoint: { max: 992, min: 768 },
                                items: 2
                              },
                              mobile: {
                                breakpoint: { max: 768, min: 0 },
                                items: 1
                              }
                            }}
                            showDots={false}
                            sliderClass=""
                            slidesToSlide={1}
                            swipeable
                          >
                            {returnDashboardData.most_returned_items.map((item) => (
                              <div key={item?.sku} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#f8f9fa', borderRadius: '8px', padding: '12px', margin: '8px', minHeight: '150px' }}>
                                <img src={item?.image ? item?.image : noImage} alt={item?.name} style={{ width: '150px', height: '150px', objectFit: 'cover' }} />
                                <div style={{ flex: 1, textAlign: 'center' }}>
                                  <div style={{ fontWeight: 'bold', fontSize: '15px', marginBottom: '4px' }}>{item?.name}</div>
                                  <div style={{ fontSize: '13px', color: '#888' }}>SKU: {item?.sku}</div>
                                </div>
                                <div style={{ color: '#435185', fontWeight: 'bold', fontSize: '18px', minWidth: '40px', textAlign: 'center' }}>Total Qty: {item?.return_count}</div>
                              </div>
                            ))}
                          </Carousel>
                        ) : (
                          <div style={{ textAlign: 'center', padding: '32px' }}>No data available</div>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </>
            
          </Row>
          </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReturnDashboard;
